import Block from "../Toiture/Block"
import MurUsageBanner from "./MurUsageBanner"
import murUsageItemData from './Mur-usage'
import BlockB from "../../Components/Block-B/BlockB"

const MurUsage = () => {

    return(
        <>
            <div class="bg-light">
                <MurUsageBanner />
                <div className="container">
                    {
                        murUsageItemData.map((block, index) => (
                            block.isBlockA ?(
                                <Block 
                                    key={index}
                                    blockTitle={block.blocTitle}
                                    blockContent={block.blocContent}
                                    hasInput={block.hasInput}
                                    inputLabel={block.inputLabel}
                                    inputDescription={block.inputDescription}
                                />
                            ):(
                                <BlockB 
                                    key={index}
                                    blockTitle={block.blocTitle}
                                    blockContent={block.blocContent}
                                    hasInput={block.hasInput}
                                    inputLabel={block.inputLabel}
                                />
                            )
                        ))
                    }
                </div>
            </div>
        </>
    )

}

export default MurUsage